/**
 * AI JavaScript | Cannlytics Website
 * Copyright (c) 2023 Cannlytics
 * 
 * Authors: Keegan Skeate <https://github.com/keeganskeate>
 * Created: 2/5/2023
 * Updated: 2/5/2023
 * License: MIT License <https://github.com/cannlytics/cannlytics/blob/main/LICENSE>
 */
import { RecipesAI } from './recipes.js';

export const ai = {

  recipes: RecipesAI,

}
